/* tslint:disable */
/* eslint-disable */
/**
 * MVC Games
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeagueInviteSummary
 */
export interface LeagueInviteSummary {
    /**
     * 
     * @type {Date}
     * @memberof LeagueInviteSummary
     */
    inviteCreatedAt: Date;
    /**
     * 
     * @type {Date}
     * @memberof LeagueInviteSummary
     */
    inviteUpdatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof LeagueInviteSummary
     */
    invitedAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueInviteSummary
     */
    invitedAccountUsername: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueInviteSummary
     */
    invitedByAccountId: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueInviteSummary
     */
    invitedByAccountUsername: string;
    /**
     * 
     * @type {Date}
     * @memberof LeagueInviteSummary
     */
    leagueCreatedAt: Date;
    /**
     * 
     * @type {string}
     * @memberof LeagueInviteSummary
     */
    leagueDescription: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueInviteSummary
     */
    leagueId: string;
    /**
     * 
     * @type {string}
     * @memberof LeagueInviteSummary
     */
    leagueName: string;
    /**
     * 
     * @type {LeagueInviteSummaryLeaguePrivacyEnum}
     * @memberof LeagueInviteSummary
     */
    leaguePrivacy: LeagueInviteSummaryLeaguePrivacyEnum;
    /**
     * 
     * @type {Date}
     * @memberof LeagueInviteSummary
     */
    leagueUpdatedAt: Date;
}


/**
 * @export
 */
export const LeagueInviteSummaryLeaguePrivacyEnum = {
    Public: 'public',
    Private: 'private'
} as const;
export type LeagueInviteSummaryLeaguePrivacyEnum = typeof LeagueInviteSummaryLeaguePrivacyEnum[keyof typeof LeagueInviteSummaryLeaguePrivacyEnum];


/**
 * Check if a given object implements the LeagueInviteSummary interface.
 */
export function instanceOfLeagueInviteSummary(value: object): value is LeagueInviteSummary {
    if (!('inviteCreatedAt' in value) || value['inviteCreatedAt'] === undefined) return false;
    if (!('inviteUpdatedAt' in value) || value['inviteUpdatedAt'] === undefined) return false;
    if (!('invitedAccountId' in value) || value['invitedAccountId'] === undefined) return false;
    if (!('invitedAccountUsername' in value) || value['invitedAccountUsername'] === undefined) return false;
    if (!('invitedByAccountId' in value) || value['invitedByAccountId'] === undefined) return false;
    if (!('invitedByAccountUsername' in value) || value['invitedByAccountUsername'] === undefined) return false;
    if (!('leagueCreatedAt' in value) || value['leagueCreatedAt'] === undefined) return false;
    if (!('leagueDescription' in value) || value['leagueDescription'] === undefined) return false;
    if (!('leagueId' in value) || value['leagueId'] === undefined) return false;
    if (!('leagueName' in value) || value['leagueName'] === undefined) return false;
    if (!('leaguePrivacy' in value) || value['leaguePrivacy'] === undefined) return false;
    if (!('leagueUpdatedAt' in value) || value['leagueUpdatedAt'] === undefined) return false;
    return true;
}

export function LeagueInviteSummaryFromJSON(json: any): LeagueInviteSummary {
    return LeagueInviteSummaryFromJSONTyped(json, false);
}

export function LeagueInviteSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeagueInviteSummary {
    if (json == null) {
        return json;
    }
    return {
        
        'inviteCreatedAt': (new Date(json['invite_created_at'])),
        'inviteUpdatedAt': (new Date(json['invite_updated_at'])),
        'invitedAccountId': json['invited_account_id'],
        'invitedAccountUsername': json['invited_account_username'],
        'invitedByAccountId': json['invited_by_account_id'],
        'invitedByAccountUsername': json['invited_by_account_username'],
        'leagueCreatedAt': (new Date(json['league_created_at'])),
        'leagueDescription': json['league_description'],
        'leagueId': json['league_id'],
        'leagueName': json['league_name'],
        'leaguePrivacy': json['league_privacy'],
        'leagueUpdatedAt': (new Date(json['league_updated_at'])),
    };
}

export function LeagueInviteSummaryToJSON(json: any): LeagueInviteSummary {
    return LeagueInviteSummaryToJSONTyped(json, false);
}

export function LeagueInviteSummaryToJSONTyped(value?: LeagueInviteSummary | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'invite_created_at': value['inviteCreatedAt'].toISOString(),
        'invite_updated_at': value['inviteUpdatedAt'].toISOString(),
        'invited_account_id': value['invitedAccountId'],
        'invited_account_username': value['invitedAccountUsername'],
        'invited_by_account_id': value['invitedByAccountId'],
        'invited_by_account_username': value['invitedByAccountUsername'],
        'league_created_at': value['leagueCreatedAt'].toISOString(),
        'league_description': value['leagueDescription'],
        'league_id': value['leagueId'],
        'league_name': value['leagueName'],
        'league_privacy': value['leaguePrivacy'],
        'league_updated_at': value['leagueUpdatedAt'].toISOString(),
    };
}

